import React from "react";
import Sidebar from "../Headers/Auths/Sidebar";
import Headers from "../Headers/Auths/Header";

const AuthLayout = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="content">
        <Headers />
        <div className="main-content">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
